import type { ReactNode } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/auth';

export function AdminLayout(): ReactNode {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuthStore();

  const handleLogout = (): void => {
    void (async (): Promise<void> => {
      try {
        await logout();
        await navigate('/login');
      } catch {
        // Logout errors are handled by the store
      }
    })();
  };

  const isActive = (path: string): boolean => location.pathname === path;

  return (
    <div className="min-h-screen bg-gray-100">
      <header className="border-b bg-red-900 text-white">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4">
          <div className="flex items-center gap-8">
            <Link to="/admin" className="text-xl font-bold">
              ProfitOS Admin
            </Link>
            <nav className="hidden md:flex items-center gap-6">
              <Link
                to="/admin"
                className={`text-sm font-medium ${isActive('/admin') ? 'text-white' : 'text-red-200 hover:text-white'}`}
              >
                Overview
              </Link>
              <Link
                to="/admin/tenants"
                className={`text-sm font-medium ${isActive('/admin/tenants') ? 'text-white' : 'text-red-200 hover:text-white'}`}
              >
                Tenants
              </Link>
              <Link
                to="/admin/users"
                className={`text-sm font-medium ${isActive('/admin/users') ? 'text-white' : 'text-red-200 hover:text-white'}`}
              >
                Users
              </Link>
              <Link
                to="/admin/sla"
                className={`text-sm font-medium ${isActive('/admin/sla') ? 'text-white' : 'text-red-200 hover:text-white'}`}
              >
                SLA Monitoring
              </Link>
              <Link
                to="/"
                className="text-sm font-medium text-red-200 hover:text-white"
              >
                Back to Dashboard
              </Link>
            </nav>
          </div>
          <div className="flex items-center gap-4">
            <div className="text-right">
              <p className="text-sm font-medium">{user?.name ?? user?.email}</p>
              <p className="text-xs text-red-200">Admin</p>
            </div>
            <button
              onClick={handleLogout}
              className="text-sm font-medium text-red-200 hover:text-white"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
